import { observable, makeObservable, action } from 'mobx';
import { Storage } from '@/utils/Storage';
import SessionStore from './session';
import ModalStore from './modal';
import SkillStore from './skill';
import grtAiStore from '.';
import preQuestionStore from './preQuestion';
import multimodalStore from './multimodal';
import { handleHistoryRecord, handleSessionList, checkBusiness, outLogin } from '@/api/grt/ai';
import routeDeerFlowMessage from '@/pages/hooks/DeerFlow/routeDeerFlowMessage';
import {
    createDeerFlowRequest as createDeerFlowRequestService,
    handleDeerFlowHistoryRequest,
    handleDeerFlowBeforeSubmit
} from '@/pages/hooks/DeerFlow/deerFlowService';
import useAippt, { handleAIPPTHistoryMessage as handleAIPPTHistoryMessageCore } from '@/pages/hooks/useAippt';
import { removeModal } from '@/utils/Page/modal';
import { isUrl } from '@/utils';
import { fileTypeMap, fileStatusDic, parseStatusDic, dateMap, defaultSkill, contentType, third_json_handler } from '@/utils/Page/constant';
import { v4 as uuidv4 } from 'uuid';
import ToastUtils from '@/utils/ToastUtils';
import { cloneDeep, set } from 'lodash';
import { formatHistoryData } from '@/pages/hooks/DeerFlow/useDeerFlow';
import { getFileStatus, getMobileHideSkills } from '@/utils/Page';
import { Display } from '@/components/Display/Display';
import DotLoading from '@/components/Loading/DotLoading';
import MessageFooter from '@/pages/pageComponents/MessageFooter';
import AiRender from '@/pages/pageComponents/MessageRender/AIRender';
import LocalRender from '@/pages/pageComponents/MessageRender/LocalRender';
import { FlowMsg } from '@/utils/Page/flowData';
import { getUserId } from '@/utils/Page';
import { XRequest } from '@ant-design/x';

import { removeTagsAndContent } from '@/utils';
import { handleFeedBack, handleMobileFeedBack } from '@/utils/Page/feedback';
import { baseAiURL } from '@/httpService/API';
let AgentChatURL = {
    agent: baseAiURL + '/agent/session/chat',
    basicAgent: baseAiURL + '/agent/basic/chat',
    multimodalAgent: baseAiURL + '/multimodal/chat',
    simulationAgent: baseAiURL + '/case_simulation/session/start'
};
let { agent, basicAgent, multimodalAgent, simulationAgent } = AgentChatURL;
export const getuuid = () => {
    return uuidv4();
};
//此处只引用方法，使用变量的时候 需要再重新取一下，否则是第一次引入的变量
// 整合skill和session里的通用方法
const { setSessionList, setSessionMap, changeCurrentSessionMapId, changeOriginMsgMap, setIsHasNewSessionId, setOriginSessionList } = SessionStore;
const {
    setCurPlugin,
    setCurSkill,
    getSkillDetail,
    isSkillNeedLogin,
    isFileChatType,
    isCaseSimulationType,
    isMultimodalLearningType,
    isDeerFlowType,
    isTargetSkillType,
    isAipptType
} = SkillStore;
class ChatStore {
    constructor() {
        makeObservable(this);
        // 初始化DeerFlow hooks - 移到外部创建以避免在class中使用React hooks
        this.deerFlowHook = null;
        this.initializeHooks();
    }

    initializeHooks() {
        // 由于 React hooks 不能在 class 组件中使用，初始化时保持为 null。
        // 真实的 hook 实例应由 React 组件在运行时注入到 store（如果需要）。
        this.deerFlowHook = null;
    }
    @observable showAgentTip = true;
    @action setShowAgentTip = (flag) => {
        this.showAgentTip = flag;
    };
    initAgentTip = () => {
        this.setShowAgentTip(true);
        setTimeout(() => {
            this.setShowAgentTip(false);
        }, 3000);
    };
    @observable showAgentModal = false;
    @action setShowAgentModal = (flag) => {
        this.showAgentModal = flag;
    };
    @observable agentId = null;
    @action
    setAgentId = (id) => {
        this.agentId = id;
    };
    @observable navigate = null;
    @action
    setNavigate = (fn) => {
        this.navigate = fn;
    };
    isNoFooterSkills = () => {
        return (
            SkillStore.isDeerFlowType(SkillStore.curSkill?.ability_id) ||
            SkillStore.isFileChatType(SkillStore.curSkill?.ability_id) ||
            SkillStore.isCaseSimulationType(SkillStore.curSkill?.ability_id)
        );
    };

    @observable isInAnswer = false; //回答过程中---用户不可输入
    @action setIsInAnswer = (flag) => {
        this.isInAnswer = flag;
    };

    // 获取当前会话相关的引用
    get originMsgMapRef() {
        return SessionStore.originMsgMap;
    }

    get currentSessionMapIdRef() {
        return SessionStore.currentSessionMapId;
    }

    get currentSessionMapIdList() {
        return SessionStore.currentSessionMapIdList;
    }

    get sessionListRef() {
        return SessionStore.originSessionList;
    }

    get skillListRef() {
        return SkillStore.originSkillList;
    }

    get curSkillRef() {
        return SkillStore.curSkill;
    }

    // 技能类型判断方法
    isTargetSkillType = (skillId, type) => {
        return SkillStore.isTargetSkillType(skillId, type);
    };

    isFileChatType = (skillId) => {
        return SkillStore.isFileChatType(skillId);
    };

    isMultimodalLearningType = (skillId) => {
        return SkillStore.isMultimodalLearningType(skillId);
    };

    isCaseSimulationType = (skillId) => {
        return SkillStore.isCaseSimulationType(skillId);
    };

    // 其他工具方法
    isSkillNeedLogin = (skill) => {
        return SkillStore.isSkillNeedLogin(skill);
    };

    authTest = async () => {
        if (this.isSkillNeedLogin()) {
            let isLogin = await this.checkIsLogin();
            if (!isLogin) {
                return false;
            }

            let isCanUse = await this.checkCanUse();
            if (!isCanUse) {
                return false;
            }
        }
        return true;
    };

    // 其他方法
    getuuid = () => {
        return uuidv4();
    };

    isNewSessionRef = { current: true };

    // TTS相关属性 (暂时设为null，后续可以扩展)
    ttsMessagesRef = { current: [] };
    ttsContentRef = { current: '' };

    // 其他方法
    handleTTSMessageUpdate = null;
    TTSNewMsg = null;
    TTSNewlist = null;
    resetVoiceCallStatus = null;
    resetMessageIdState = null;
    //当前会话的消息记录是否加载中
    @observable recordLoading = false; //记录加载中状态
    @action setRecordLoading = (flag) => {
        this.recordLoading = flag;
    };
    @observable loading = false; //辅助每个会话的loading，解决回答过程中会出现think和answer标签的问题
    @action setLoading = (flag) => {
        this.loading = flag;
    };
    //引用
    @observable references = [];
    @action setReferences = (data) => {
        this.references = data;
    };
    //附件
    @observable agentFile = [];
    // @action setAgentFile = (data) => {
    //     this.agentFile = data;
    // };
    //解决竟态问题
    setAgentFile = (newValue) => {
        // 若传入的是函数，执行函数并将返回值作为新状态
        this.agentFile = typeof newValue === 'function' ? newValue(this.agentFile) : newValue;
    };
    //输入内容
    @observable content = ''; //输入框的内容
    @action setContent = (data) => {
        this.content = data;
    };
    @observable side = 'web';
    @action
    setSide = (side) => {
        this.side = side;
    };
    //点击隔离技能
    choseApartSkill = (skill) => {
        this.resetSession({ skill });
    };
    //清空发送数据
    clearSendData = () => {
        this.setContent('');
        this.setAgentFile([]);
        // setReferences([]);
    };
    //跳转到指定会话
    linkToSession = (session_id, params) => {
        let side = this.side || 'mobile';
        let agentId = this.agentId;
        if (session_id) {
            this.navigate(`/${side}/o/${agentId}/chat/${session_id}`, params);
        } else {
            this.navigate(`/${side}/o/${agentId}/chat`, params);
        }

        removeModal();
    };
    //重置会话至初始状态
    resetSession = (data = {}) => {
        let { skill } = data;
        changeCurrentSessionMapId(null);
        setIsHasNewSessionId(false);
        setCurPlugin([]);
        // 使用传入的技能或从技能列表中获取第一个通用技能
        const defaultFromBackend = SkillStore.originSkillList && SkillStore.originSkillList.length > 0 ? SkillStore.originSkillList[0] : defaultSkill;
        setCurSkill(skill || defaultFromBackend);
        this.clearSendData();
        this.setReferences([]);
        this.linkToSession();
        multimodalStore.setMultimodalReference(null);
    };
    //粘贴链接时，判断是否需要添加链接卡片
    handlePaste = (e) => {
        let { agentFile, setAgentFile, setReferences } = this;
        const pastedText = e.clipboardData.getData('text');
        let needAddLinkCard = false;
        if (isUrl(pastedText)) {
            if (this.isFileChatType(SkillStore.curSkill?.ability_id)) {
                if (agentFile.length === 0) {
                    needAddLinkCard = true;
                }
                if (agentFile.length === 1 && agentFile[0].type === fileTypeMap.link) {
                    needAddLinkCard = true;
                }
            }
            if (needAddLinkCard) {
                setAgentFile([
                    {
                        file_url: pastedText,
                        type: fileTypeMap.link,
                        name: pastedText,
                        status: fileStatusDic.success,
                        uid: uuidv4(),
                        parse_status: parseStatusDic.ing
                    }
                ]);
                setReferences([]);
                e.preventDefault(); // 阻止粘贴
                return;
            }
        }

        // if (agentFile.length === 0 && isFileChatType(SkillStore.curSkill?.ability_id)) {
        //     const pastedText = e.clipboardData.getData('text');
        //     if (isUrl(pastedText)) {
        //         setAgentFile([
        //             {
        //                 file_url: pastedText,
        //                 type: fileTypeMap.link,
        //                 name: pastedText,
        //                 status: 2
        //             }
        //         ]);
        //         e.preventDefault(); // 阻止粘贴
        //         return;
        //     }
        // }
    };
    //跳转到登录
    goLogin = () => {
        let redirect = `${window.location.href}`;

        if (this.side === 'web') {
            window.location.href = `${origin}/login?redirect=${redirect}`;
        } else {
            window.location.href = `${origin}/mobile/login?redirect=${encodeURIComponent(redirect)}`;
        }
    };
    //验证是否登录
    checkIsLogin = async (needLogin = true) => {
        const res = await grtAiStore.checkLogin();
        if (res) {
            return true;
        }
        if (needLogin) {
            ToastUtils.showToast('请登录');
            setTimeout(() => {
                this.goLogin();
            }, 500);
        }

        return false;
    };
    //验证是否有使用权限--是否学员等
    checkCanUse = async () => {
        let res = await checkBusiness({ agent_id: this.agentId });
        if (!res || !res.success || !res.data) {
            ToastUtils.showToast(res?.msg || '');
            preQuestionStore.setCanClick(true);
            return false;
        }
        return true;
    };
    //不生成新消息，在原消息上发送消息
    createRequestByMsgId = (msgId, requestChatParams) => {
        let { session_id } = requestChatParams;
        let oldMessages = SessionStore.originMsgMap[session_id]?.messages || [];
        let len = oldMessages.length;
        let obj = {
            nextId: msgId,
            msgList: oldMessages,
            requestChatParams: requestChatParams,
            status: 'complete'
        };
        this.handleChat(obj, oldMessages[len - 1]);
    };
    //重新生成
    reGenerate = (info) => {
        const { sessionMap, currentSessionMapId } = SessionStore;
        let curSession = sessionMap[currentSessionMapId];
        if (curSession.loading) {
            return false;
        }
        // this.changeSessionMapItem(currentSessionMapId, { loading: true });

        if (!info) {
            return false;
        }

        let requestChatParams = {
            session_id: info?.session_id || currentSessionMapId,
            question: info?.question
        };
        this.onSubmitMsg(requestChatParams);
    };
    feedBack = (info) => {
        if (this.side === 'web') {
            handleFeedBack(info, this.checkIsLogin);
        } else {
            handleMobileFeedBack(info, this.checkIsLogin);
        }
    };
    //复制
    copy = (info) => {
        let str = info.answerContent;
        str = removeTagsAndContent(str, 'citation');
        str = str.replace(/[\r\n]/g, '');
        navigator.clipboard.writeText(str);
        // ToastUtils.showToast('复制成功');
    };
    //会话过程中--处理页面显示的消息列表--，如果处理历史记录先使用 handelSessionHistoryMessage
    handleMessages = (messages, from = 'chat') => {
        let inInanswer = false; // 默认不在回答中，避免隐藏按钮

        // 只有最新的消息才会考虑loading状态
        // 只有当前正在处理的新消息才应该隐藏按钮
        if (from === 'chat' && SessionStore.sessionMap[SessionStore.currentSessionMapId]?.loading) {
            inInanswer = true;
        }

        // 过滤掉隐藏的消息（如researcher和reporter消息）
        const filteredMessages = messages.filter((msg) => !msg.isHidden);
        const cloneMsg = cloneDeep(filteredMessages);
        // console.log(cloneMsg, 'cloneMsg');
        let len = filteredMessages.length;

        let res = [];
        if (len > 0) {
            res = cloneMsg.map((item, index) => {
                let { content, status, role } = item;

                const itemHandler = item.handler || item.multimodal;
                const isMultimodalHandler = itemHandler === contentType.multimodal_learning || itemHandler === contentType.multimodal;

                let finalContent = content;
                let loadingValue = status === 'loading';
                if (isMultimodalHandler) {
                    // 🔥 检查是否有引用状态（multimodal_reference 或 references）
                    const hasReference = multimodalStore.multimodal_reference || (Array.isArray(this.references) && this.references.length > 0);

                    if (hasReference) {
                        // 有引用状态时，根据内容情况决定是否显示三个点
                        const hasContent = finalContent && typeof finalContent === 'string' && finalContent.trim() !== '';
                        if (!hasContent && status === 'loading') {
                            // 没有内容且还在loading时，显示三个点
                            loadingValue = true;
                        } else {
                            // 有内容时，流式输出，不显示三个点
                            loadingValue = false;
                        }
                    }
                }
                return {
                    status,
                    loadingRender: () => {
                        return <DotLoading></DotLoading>;
                    },
                    loading: loadingValue,
                    role: role === 'local' ? 'local' : 'ai', // 保持原始角色，不要强制转换
                    content: finalContent,
                    footer: () => {
                        return (
                            <MessageFooter
                                copy={this.copy}
                                feedBack={this.feedBack}
                                reGenerate={this.reGenerate}
                                len={len}
                                side={this.side}
                                item={item}
                                index={index}
                                status={status}
                                inInanswer={inInanswer}
                            ></MessageFooter>
                        );
                    },

                    messageRender: (message) => {
                        // 修复：正确区分AI和用户消息，确保用户消息不被当作AI消息处理
                        if (role !== 'local') {
                            // 将当前会话 id 传入 AiRender，便于组件做更可靠的最新消息判断
                            return <AiRender message={message} side={this.side} item={item} sessionId={SessionStore.currentSessionMapId}></AiRender>;
                        }
                        return (
                            <>
                                <LocalRender message={message} side={this.side} item={item}></LocalRender>
                            </>
                        );
                    }
                };
            });
        }
        return res;
    };
    //处理历史记录数据--整理成前端需要的格式
    formatHistoryRecord = async (data, session) => {
        let temData = await formatHistoryData(data, session?.session_id, isDeerFlowType(session?.skill_id)); //后端返回来的处理后的数据
        let res = this.handleMessages(temData, 'history'); //页面展示的数据----antdx--
        return {
            showMsg: res,
            allMsg: temData
        };
    };
    //保存时插件字段处理
    getPluginJson = (curPlugin) => {
        let obj = {};
        if (curPlugin) {
            curPlugin.forEach((ele) => {
                obj[ele.name] = true;
            });
        }

        //如果插件配置了保持开启，需要将对应字段设为true
        if (SkillStore.curSkill?.plugin_json) {
            SkillStore.curSkill?.plugin_json.forEach((item) => {
                if (item.choice === 1) {
                    obj[item.name] = true;
                }
            });
        }

        return obj;
    };
    isNewChat = (session_id) => {
        return Number(session_id) === 0;
    };
    //开始新的对话--基于当前会话开启的新会话，沿用当前会话的skill
    startNewMsg = () => {
        if (!SkillStore?.skillAvailable) {
            ToastUtils.showToast('该技能暂不可用');
            return;
        }
        // deerFlowHook.setPlanButtonsDisabled(false); // 开始新会话时重置按钮状态
        // 优先使用当前技能，否则使用从后端获取的第一个技能
        const defaultFromBackend = SkillStore.originSkillList && SkillStore.originSkillList.length > 0 ? SkillStore.originSkillList[0] : defaultSkill;
        let skill = defaultFromBackend;

        if (SkillStore.curSkill?.ability_id) {
            skill = SkillStore.curSkill;
        }

        if (SessionStore.currentSessionMapId) {
            this.resetSession({ skill });
        } else {
            ToastUtils.showToast('已经是最新对话了');
        }
    };
    isSkillNeedLogin = (skill) => {
        let targetSkill = skill || SkillStore.curSkill;
        // 🔥 优化：根据 login_restrict 字段判断是否需要登录
        // login_restrict = 0: 不需要登录
        // login_restrict = 1: 需要登录
        // 如果字段不存在，默认需要登录
        if (targetSkill?.login_restrict === 0) {
            return false; // 明确标记为不需要登录
        }
        if (targetSkill?.login_restrict === 1) {
            return true; // 需要登录
        }
        // 兜底：如果没有 login_restrict 字段，默认需要登录（保持向后兼容）
        return true;
    };
    authTest = async () => {
        if (this.isSkillNeedLogin()) {
            let isLogin = await this.checkIsLogin();
            if (!isLogin) {
                return false;
            }

            let isCanUse = await this.checkCanUse();
            if (!isCanUse) {
                return false;
            }
        }
        return true;
    };
    onSubmitMsg = async (params, isPreQuestion = false) => {
        console.log(isPreQuestion, 'isPreQuestion');
        let { curSkill } = SkillStore;
        if (!preQuestionStore.canClick) {
            ToastUtils.showToast('当前正在生成结果，请稍后操作');
            return false;
        }
        if (!this.isCanSendMsg(params.question, isPreQuestion)) {
            return false;
        }
        preQuestionStore.setCanClick(false);
        params.question = params.question.trim();

        if (!isPreQuestion) {
            params.file_json = this.agentFile.filter((ele) => ele.status === fileStatusDic.success && ele.parse_status === parseStatusDic.success);
            params.references = this.references;
            this.clearSendData();
        } else {
            params.file_json = [];
            params.references = [];
        }

        // 🔥 新增：检查当前技能是否已下架（left_side === 0），如果下架则切换到通用技能
        if (curSkill && curSkill.left_side === 0) {
            console.warn('⚠️ 当前技能已下架，切换到通用技能发送消息');
            // 🔥 修复：查找通用技能（ability_id === -1），而不是菜单第一个技能
            const generalSkill = SkillStore.originSkillList.find((ele) => String(ele.ability_id) === '-1') || defaultSkill;
            setCurSkill(generalSkill);
        }

        const requestChatParams = {
            user_id: getUserId(),
            agent_id: this.agentId,
            session_id: SessionStore.currentSessionMapId || '0',
            tenant_id: Storage.get('tenantId'),
            plugin_json: this.getPluginJson(SkillStore.curPlugin),
            skill_id: curSkill?.ability_id ? String(curSkill.ability_id) : '',
            // skill_name: curSkill?.ability_name || '',
            // skill_describe: curSkill?.description || '',
            apart: curSkill?.apart,
            ...params
        };

        let isNeedCheckCanuse = false;
        if (isSkillNeedLogin()) {
            let isLogin = await this.checkIsLogin();
            if (!isLogin) {
                return false;
            }
            isNeedCheckCanuse = true;
        } else {
            let isLogin = await this.checkIsLogin(false); //不需要跳转到登录页
            if (isLogin) {
                isNeedCheckCanuse = true;
            }
        }
        //登录状态下 新会话需要调用此接口以保证学员能够正确添加
        if (isNeedCheckCanuse && this.isNewChat(requestChatParams.session_id)) {
            let isCanUse = await this.checkCanUse();
            if (!isCanUse) {
                return false;
            }
        }

        this.beforeSubmitMsg(requestChatParams, isPreQuestion);
    };
    //发送消息前 处理消息列表，追加提问消息及AI 回答中的loading消息
    beforeSubmitMsg = (requestChatParams, isPreQuestion) => {
        let session_id = requestChatParams?.session_id;
        // 如果没有显式传入 session_id（例如从 UI 按钮触发没有携带），回退为当前 store 中的会话 id
        if (session_id === undefined || session_id === null) {
            session_id = SessionStore.currentSessionMapId;
            requestChatParams.session_id = session_id;
        }
        let nextContent = requestChatParams?.question;
        let file_json = requestChatParams?.file_json;
        let references = requestChatParams?.references || [];
        //新会话
        const isNewSession = !session_id || session_id === '0';
        const isDeerFlow = SkillStore.isDeerFlowType(requestChatParams.skill_id);
        if (isNewSession) {
            if (isDeerFlow) {
                // 使用 DeerFlow 服务在非 hook 环境中处理新会话逻辑（与 useDeerFlow.handleDeerFlowBeforeSubmit 保持一致）
                try {
                    const result = handleDeerFlowBeforeSubmit(requestChatParams, isNewSession, {
                        // pass ref-like objects so the shared service reads .current consistently (matches hook usage)
                        currentSessionMapIdRef: { current: SessionStore.currentSessionMapId },
                        sessionListRef: { current: SessionStore.originSessionList },
                        formatSessionList: this.formatSessionList.bind(this),
                        linkToSession: this.linkToSession.bind(this),
                        changeOriginMsgMapRef: SessionStore.changeOriginMsgMap,
                        originMsgMapRef: { current: SessionStore.originMsgMap },
                        editPlanMode: (this.deerFlowHook && this.deerFlowHook.editPlanMode) || false
                    });
                    if (result && result.session_id !== undefined) {
                        session_id = result.session_id;
                    }
                } catch (e) {
                    console.error('DeerFlow beforeSubmit service error:', e);
                }
            } else {
                // 非 DeerFlow 会话使用生成的 UUID
                session_id = getuuid();
                changeCurrentSessionMapId(session_id);
                this.linkToSession(session_id, { replace: true });
                // TODO: ConfigFactory(session_id, session_id);
                requestChatParams.session_key = session_id;
                let curList = SessionStore.originSessionList ? SessionStore.originSessionList : [];
                // 🔥 修复：添加 handler_json 字段，确保刷新后能正确识别技能类型
                const handler = SkillStore.curSkill?.third_json?.handler;
                let data = [
                    {
                        session_name: '新会话',
                        time_range: '1',
                        session_id: session_id,
                        skill_id: requestChatParams?.skill_id,
                        handler_json: handler ? [handler] : [] // 添加 handler_json
                    },
                    ...curList
                ];
                this.formatSessionList(data);
            }
        } else if (isDeerFlow) {
            // 现有DeerFlow会话的处理
            handleDeerFlowBeforeSubmit(requestChatParams, isNewSession, {
                currentSessionMapIdRef: { current: SessionStore.currentSessionMapId },
                sessionListRef: { current: SessionStore.originSessionList },
                formatSessionList: this.formatSessionList.bind(this),
                linkToSession: this.linkToSession.bind(this),
                changeOriginMsgMapRef: SessionStore.changeOriginMsgMap,
                originMsgMapRef: { current: SessionStore.originMsgMap },
                editPlanMode: (this.deerFlowHook && this.deerFlowHook.editPlanMode) || false
            });
        }

        // 确保使用当前会话的 session_id
        const currentSessionId = SessionStore.currentSessionMapId || session_id;

        // Prefer originMsgMap (the canonical message list). If it's empty (e.g., after a stop),
        // fall back to the sessionMap's view messages so we don't lose previous content when sending again.
        let oldMessages = SessionStore.originMsgMap[currentSessionId]?.messages || [];
        if (!Array.isArray(oldMessages) || oldMessages.length === 0) {
            try {
                const fallbackViewMsgs = SessionStore.sessionMap[currentSessionId]?.messages || [];
                if (Array.isArray(fallbackViewMsgs) && fallbackViewMsgs.length > 0) {
                    // Map view messages to a conservative original-like shape so subsequent logic can operate.
                    oldMessages = fallbackViewMsgs.map((vm, idx) => {
                        return {
                            _id: vm._id || vm.temId || `fallback_${idx}`,
                            temId: vm.temId || vm._id || `fallback_${idx}`,
                            content: vm.content || vm.answerContent || '',
                            status: vm.status || (vm.loading ? 'loading' : 'complete'),
                            role: vm.role || (vm.footer ? 'ai' : 'local'),
                            session_id: currentSessionId
                        };
                    });
                } else {
                    oldMessages = [];
                }
            } catch (e) {
                oldMessages = [];
            }
        }

        let len = oldMessages.length;
        const myLocalId = 'msg_' + len;
        const aiLocalId = 'msg_' + (len + 1);
        // 🔥 优先从 requestChatParams 中读取摘要（从 submitMsg 传递过来的），如果没有则从 ref 读取
        const currentMultimodalReference = !isPreQuestion ? requestChatParams.multimodal_reference || multimodalStore.multimodalReference : null;

        const sanitizedMultimodalReference = currentMultimodalReference
            ? {
                  title: currentMultimodalReference.title || '多模态学习',
                  description: currentMultimodalReference.description || '',
                  videoCount: currentMultimodalReference.videoCount || 0,
                  firstVideoTitle: currentMultimodalReference.firstVideoTitle || '',
                  reference_id: currentMultimodalReference.reference_id,
                  // 保留 onListClick，保证聊天记录里的引用也能直接展开视频列表
                  onListClick: currentMultimodalReference.onListClick
              }
            : null;

        const newMessages = [
            ...oldMessages,
            {
                ...requestChatParams,
                role: 'local',
                status: 'complete',
                temId: myLocalId,
                content: nextContent,
                file_json: file_json,
                references: sanitizedMultimodalReference ? currentMultimodalReference?.videoReferences || [] : references, //如果有多模态引用，就用多模态视频，否则用原始引用
                multimodal_reference: sanitizedMultimodalReference
            },
            {
                role: 'ai',
                status: 'loading',
                temId: aiLocalId,
                question: nextContent,
                content: '',
                handler: SkillStore.curSkill?.third_json?.handler
            }
        ];

        this.setLoading(true);
        let res = this.handleMessages(newMessages);
        console.log(res, 'ressssss');
        // 使用当前会话ID更新消息
        this.changeSessionMapItem(currentSessionId, { loading: true, messages: res }, newMessages);
        if (!preQuestionStore.canClick) {
            preQuestionStore.setCanClick(true);
        }

        //发送时只要带附件就要更新引用文件
        if (!isPreQuestion && file_json.length && isFileChatType(requestChatParams.skill_id)) {
            // let temdata = agentFile.filter((ele) => ele.status === fileStatusDic.success && ele.parse_status === parseStatusDic.success);
            this.setReferences(file_json);
        }

        this.createRequest(aiLocalId, newMessages, requestChatParams, isNewSession);
    };
    //当前ai回答的消息更新时，更新消息列表
    updateMsgListByCurmsg = (currentMsg, processing, msgList, localsession_key) => {
        let { sessionMap, currentSessionMapId } = SessionStore;
        let { curSkill } = SkillStore;
        // 判断是否为 DeerFlow 聊天
        const isDeerFlow = curSkill?.third_json?.handler === 'deerflow';
        let effectiveSessionId = currentMsg.session_id;

        if (isDeerFlow) {
            // 将 DeerFlow 路由与处理逻辑移到专用函数
            const returnedId = routeDeerFlowMessage({
                curSkillRef: { current: SkillStore.curSkill },
                currentMsg,
                currentSessionMapIdRef: SessionStore.currentSessionMapIdRef || null,
                linkToSession: this.linkToSession ? this.linkToSession.bind(this) : null,
                deerFlowHook: null,
                processing,
                msgList,
                localsession_key,
                sessionListRef: { current: SessionStore.originSessionList || [] },
                sessionMapRef: { current: SessionStore.sessionMap || {} },
                formatSessionList: this.formatSessionList ? this.formatSessionList.bind(this) : null,
                changeSessionMapItem: this.changeSessionMapItem ? this.changeSessionMapItem.bind(this) : null,
                isInAnswerRef: null,
                side: this.side
            });
            if (returnedId) {
                effectiveSessionId = returnedId;
                try {
                    // 把会话 id 写回 store并跳转到真实会话，确保侧栏会被选中
                    changeCurrentSessionMapId(returnedId);
                    this.linkToSession(returnedId, { replace: true });

                    // 确保会话列表包含该真实 session：尝试用 placeholder 替换或在前端插入
                    try {
                        const curList = SessionStore.originSessionList ? [...SessionStore.originSessionList] : [];

                        const handler = SkillStore.curSkill?.third_json?.handler;
                        // 优先：若 curList 中已存在 returnedId，则使用该条目的 session_name
                        const existingEntry = curList.find((it) => it && String(it.session_id) === String(returnedId));
                        const newSessionName =
                            (existingEntry && existingEntry.session_name) || currentMsg?.question || curList[0]?.session_name || '新会话';
                        const newSessionEntry = {
                            session_name: newSessionName,
                            time_range: '1',
                            session_id: returnedId,
                            skill_id: SkillStore.curSkill?.ability_id || '',
                            handler_json: handler ? [handler] : []
                        };

                        // Remove any existing entries that are placeholders or already the returnedId to avoid duplicates
                        const filtered = curList.filter((it) => {
                            if (!it) return false;
                            if (String(it.session_id) === String(returnedId)) return false; // remove exact existing
                            if (it.session_id === '' || it.session_name === '新会话' || it.session_id === currentMsg?.temSessionId) return false; // remove placeholders
                            return true;
                        });

                        const data = [newSessionEntry, ...filtered];
                        this.formatSessionList(data);
                    } catch (e2) {
                        console.warn('ensure session list contains returnedId failed:', e2);
                    }
                } catch (e) {
                    console.warn('failed to set current session after routeDeerFlowMessage:', e);
                }
            }
        }

        //新会话处理
        if ((localsession_key || isDeerFlow) && !sessionMap[effectiveSessionId]) {
            let curList = SessionStore.originSessionList ? SessionStore.originSessionList : [];
            let localList = curList[0];

            if (!isDeerFlow && localsession_key) {
                // 非 DeerFlow 新会话的原有逻辑

                let fileName =
                    currentMsg?.file_json[0]?.title || `${currentMsg?.file_json[0]?.name}.${currentMsg?.file_json[0]?.ext_type}` || '新会话';
                if (isCaseSimulationType(curSkill?.ability_id)) {
                    fileName = currentMsg?.component?.title;
                }
                curList[0] = {
                    ...localList,
                    status: currentMsg?.status,
                    session_name: currentMsg.question || fileName,
                    session_id: effectiveSessionId,
                    // 🔥 修复：保留 handler_json，确保跳转到真实会话ID后技能类型不丢失
                    handler_json: localList?.handler_json || []
                };

                let data = [...curList];

                // 非 DeerFlow 会话的原有跳转逻辑
                if (currentSessionMapId === localsession_key) {
                    changeCurrentSessionMapId(effectiveSessionId);
                    this.linkToSession(effectiveSessionId, { replace: true });
                }
                this.formatSessionList(data);
            }
        }

        const cloneMessages = cloneDeep(msgList);
        //找到正在生成的消息
        let index = cloneMessages.findIndex((item) => {
            let targetId = item._id || item.temId;
            // 确保只匹配AI消息，避免匹配到用户消息
            return targetId === currentMsg.temId && item.role === 'ai';
        });

        if (index !== -1) {
            let data = {
                ...cloneMessages[index],
                ...currentMsg,
                // 如果 currentMsg.content 有值（包括空字符串），就使用它
                content: currentMsg.content !== undefined && currentMsg.content !== null ? currentMsg.content : cloneMessages[index].content || '',
                // 确保 processing 字段被正确传递（从 currentMsg 或根据 processing 参数设置）
                processing: currentMsg.processing !== undefined ? currentMsg.processing : processing
            };
            cloneMessages[index] = data;
            //新会话结束后 更新会话历史列表
            if (processing === false) {
                this.changeSessionMapItem(effectiveSessionId, { loading: false });

                this.setIsInAnswer(false);
                if (this.isNeedGetSessionList && this.side === 'web') {
                    this.isNeedGetSessionList = false;
                    //  修复：调用获取会话列表函数更新最近会话
                    // getSessionList({
                    //     user_id: getUserId(),
                    //     agent_id: agentId
                    // });
                }
            } else {
                // 确保处理中的消息状态正确设置
                this.changeSessionMapItem(effectiveSessionId, { loading: true });

                this.setIsInAnswer(true);
            }

            let res = this.handleMessages(cloneMessages);

            // 🔥 检测是否为带引用的多模态消息，如果有内容则不显示loading
            let finalLoading = processing === false ? false : true;
            try {
                const isMultimodalRef =
                    currentMsg?.multimodal_reference || (Array.isArray(currentMsg?.references) && currentMsg.references.length > 0);
                const curContent =
                    currentMsg?.content !== undefined && currentMsg?.content !== null
                        ? String(currentMsg.content)
                        : String(cloneMessages[index]?.content || '');
                const hasContent = curContent && curContent.trim() !== '';
                if (isMultimodalRef && hasContent) {
                    finalLoading = false;
                }
            } catch (e) {
                console.log(e, 'e');
            }

            this.changeSessionMapItem(
                effectiveSessionId,
                {
                    messages: res,
                    loading: finalLoading
                },
                cloneMessages
            );
        }
    };
    //发送并接收聊天数据
    handleChat = (params, appendData = false) => {
        let curSkill = SkillStore.curSkill;
        let flowMsg = new FlowMsg();
        const { requestChatParams, msgList, nextId } = params;
        // console.log(msgList, 'msgListmsgList');
        let latestMsg = {};
        this.setIsInAnswer(true);
        //当前消息 属于哪个会话
        let curSessionId = requestChatParams.session_key ? requestChatParams.session_key : requestChatParams.session_id;
        let reqUrl = agent;
        if (isFileChatType(curSkill?.ability_id)) {
            requestChatParams.tenant_id = Storage.get('tenantId');
            reqUrl = basicAgent;
        }
        if (isCaseSimulationType(curSkill?.ability_id)) {
            reqUrl = simulationAgent;
        }
        if (this.isNewChat(requestChatParams.session_id)) {
            requestChatParams.session_id = '0';
        }
        if (isMultimodalLearningType(curSkill?.ability_id)) {
            reqUrl = multimodalAgent;
        }
        const agentRequest = XRequest({
            baseURL: reqUrl
        });
        agentRequest.create(requestChatParams, {
            onSuccess: (response) => {
                this.setLoading(false);
            },
            onUpdate: (message) => {
                this.setLoading(false); //暂时解决加载时会出现think标签的问题
                if (message.data) {
                    const data = JSON.parse(message.data);
                    console.log(data, 'data');
                    let { answer, event, success, ...otherParams } = data;
                    flowMsg.handleFlowMsg(data, appendData);
                    latestMsg = {
                        ...requestChatParams,
                        ...otherParams,
                        temId: nextId,
                        answerContent: flowMsg.answerContent,
                        content: flowMsg.messageResult,
                        web_result: flowMsg.web_result,
                        retrieval_result: flowMsg.retrieval_result,
                        course_result: flowMsg.course_result,
                        // Consider multimodal and recommend results as completion signals
                        // 对于多模态引用消息，如果有内容就设置为完成状态
                        status:
                            flowMsg.answerContent ||
                            flowMsg.messageResult ||
                            flowMsg.ai_evaluation ||
                            flowMsg.multimodal_learning_result ||
                            flowMsg.recommend_course_result ||
                            flowMsg.card_result
                                ? 'complete'
                                : 'loading',
                        recommend_course_result: flowMsg.recommend_course_result,
                        multimodal_learning_result: flowMsg.multimodal_learning_result,
                        ai_evaluation: flowMsg.ai_evaluation,
                        // 对于多模态引用消息，如果有内容就停止加载状态
                        processing: flowMsg.processing,
                        card_result: flowMsg.card_result
                    };
                    //新会话第一次会话结束后，需要查询会话列表
                    if (
                        this.side === 'web' &&
                        this.isNewChat(requestChatParams.session_id) &&
                        this.isNeedGetSessionList === false &&
                        latestMsg.session_id
                    ) {
                        this.setIsNeedGetSessionList(true);
                    }
                } else {
                    ToastUtils.showToast(message.msg || '错误');
                    latestMsg = {
                        ...requestChatParams,
                        temId: nextId,
                        content: message.msg || '错误',
                        web_result: [],
                        retrieval_result: [],
                        status: 'complete'
                    };
                }

                this.updateMsgListByCurmsg(latestMsg, latestMsg.processing, msgList, requestChatParams.session_key);
            },
            onError: (error) => {
                console.error(error);
                this.changeSessionMapItem(curSessionId, { loading: false });
                this.setLoading(false);
            }
        });
    };
    //创建会话请求
    createRequest = async (nextId, msgList, requestChatParams, isNewSession = false) => {
        const isDeerFlow = SkillStore.isDeerFlowType(requestChatParams.skill_id);
        if (isDeerFlow) {
            try {
                await createDeerFlowRequestService(nextId, msgList, requestChatParams, isNewSession, {
                    updateMsgListByCurmsg: this.updateMsgListByCurmsg ? this.updateMsgListByCurmsg.bind(this) : null,
                    handleMessages: this.handleMessages ? this.handleMessages.bind(this) : null,
                    changeSessionMapItem: this.changeSessionMapItem ? this.changeSessionMapItem.bind(this) : null,
                    changeOriginMsgMapRef: SessionStore.changeOriginMsgMap,
                    originMsgMapRef: SessionStore.originMsgMap,
                    isInAnswerRef: { current: this.isInAnswer },
                    currentSessionMapIdRef: SessionStore.currentSessionMapId,
                    checkIsLogin: this.checkIsLogin ? this.checkIsLogin.bind(this) : null,
                    historyPollingTimers: (this.deerFlowHook && this.deerFlowHook.historyPollingTimers) || new Map(),
                    editPlanMode: (this.deerFlowHook && this.deerFlowHook.editPlanMode) || false,
                    lastThreadIdRef: { current: SessionStore.currentSessionMapId },
                    requestSessionId: SessionStore.currentSessionMapId
                });
                return;
            } catch (e) {
                console.error('DeerFlow service error:', e);
            }
        }

        let obj = {
            nextId: nextId,
            msgList: msgList,
            requestChatParams: requestChatParams
        };
        this.handleChat(obj);
    };
    //获取会话列表
    getSessionList = async (params) => {
        let data =
            {
                user_id: getUserId(),
                agent_id: this.agentId
            } || params;
        const res = await handleSessionList(data);
        // setUserid(data.user_id);
        let temData = res?.data || [];
        if (this.side === 'mobile') {
            let mobileHideSkills = getMobileHideSkills();

            temData = temData.filter((ele) => {
                return !mobileHideSkills.some((item) => ele?.handler_json.includes(item));
            });
        }
        if (res && res.success) {
            this.formatSessionList(temData);
        }
    };
    //将会话列表处理成前端需要的格式
    formatSessionList = (data = []) => {
        let sessionIds = [];
        let curSessionObj = {};
        if (!data) {
            return false;
        }

        let arr1 = [],
            arr2 = [],
            arr3 = [];
        data.forEach((item) => {
            sessionIds.push(item.session_id);
            if (item.session_id === SessionStore.currentSessionMapId) {
                curSessionObj = item;
            }
            item.checked = false;
            if (item.time_range === '1') {
                arr1.push(item);
            } else if (item.time_range === '2') {
                arr2.push(item);
            } else if (item.time_range === '3') {
                arr3.push(item);
            }
        });

        setSessionList({
            1: {
                icon: 'icon-jintian',
                name: dateMap[1],
                list: arr1
            },
            2: {
                icon: 'icon-zuotian',
                name: dateMap[2],
                list: arr2
            },
            3: {
                icon: 'icon-qitian',
                name: dateMap[3],
                list: arr3
            }
        });
        setOriginSessionList(data);

        // 存在会话id（不在新对话中），但是会话列表中没有找到对应的会话，重置会话
        if (SessionStore.currentSessionMapId && !curSessionObj.session_id) {
            this.resetSession();
        }
    };
    isHasUnFinishedEvaluation = () => {
        let msgs = SessionStore.getCurSessionMsgs();
        let len = msgs.length;
        if (len) {
            let ai_evaluation = msgs[len - 1].ai_evaluation;
            if (ai_evaluation && ai_evaluation?.ai_evaluation_result?.status !== 1 && ai_evaluation?.ai_evaluation_result?.status !== 3) {
                return true;
            }
        }
        return false;
    };
    //回答中禁止操作
    isCanSendMsg = (msg, isPreQuestion = false) => {
        let { curSkill } = SkillStore;
        let { sessionMap, currentSessionMapId } = SessionStore;
        if (isCaseSimulationType(curSkill?.ability_id)) {
            console.log('判断上一个流程是否完事');
            return true;
        }
        //输入框内的可以取content字段，重新生成、预设问题需要传入msg
        let message = msg || this.content;
        if (sessionMap[currentSessionMapId] && sessionMap[currentSessionMapId]?.loading) {
            ToastUtils.showToast('当前正在生成结果，请稍后操作');
            return false;
        }
        if (isTargetSkillType(curSkill?.ability_id, third_json_handler.ai_evaluation)) {
            if (this.isHasUnFinishedEvaluation()) {
                ToastUtils.showToast('当前流程未完成');
                return false;
            }
        }
        if (!isPreQuestion) {
            let { inUpload, uploadSuccess } = getFileStatus(this.agentFile);
            if ((!message || message.trim().length === 0) && uploadSuccess.length === 0) {
                return false;
            }

            //如果有附件上传中或者上传失败--不允许发送消息(有一个上传成功的就可以发送)
            if (inUpload.length) {
                return false;
            }
        }
        //无附件--不能发送空白消息

        return true;
    };

    //处理当前会话及对应的历史消息列表
    handelSessionHistoryMessage = async (historyMessage, session = {}) => {
        let { showMsg, allMsg } = await this.formatHistoryRecord(historyMessage, session);
        console.log(allMsg, 'allMsgallMsg');
        // 🔥 修正：检查最后一条AI消息的content是否为空（判断是否需要轮询）
        const lastMessage = allMsg.length > 0 ? allMsg[allMsg.length - 1] : null;
        const lastAiMessage = [...allMsg].reverse().find((msg) => msg.role === 'ai');

        // 判断是否需要轮询的条件：
        // 1. 最后一条消息是用户消息（等待AI回复）
        // 2. 或者最后一条AI消息的content为空（AI还在生成中）
        // 3. 🔥 新增：对于DeerFlow报告，检查是否有未完成的报告任务
        const hasUnrepliedUserMessage = lastMessage && lastMessage.role === 'local' && lastMessage.status === 'complete';
        const hasEmptyAiResponse = lastAiMessage && (!lastAiMessage.content || lastAiMessage.content.trim() === '');

        // 检查是否有加载或回答状态的消息
        const hasLoadingMessage = allMsg.some((msg) => msg.status === 'loading');
        const hasAnsweringMessage = allMsg.some((msg) => msg.status === 'answering');

        // 🔥 新增：对于DeerFlow报告，检查本地存储的canPause状态
        let hasDeerFlowReportInProgress = false;

        // 🔥 修复：检查是否需要轮询获取AI回复
        const needsPolling =
            (isDeerFlowType(session?.skill_id) || isAipptType(session?.skill_id)) &&
            (hasUnrepliedUserMessage || hasEmptyAiResponse || hasDeerFlowReportInProgress);

        // 🔥 修复：特殊处理DeerFlow会话的loading状态
        // 对于DeerFlow会话，如果本地存储中canPause为false，说明任务已完成，不应该显示loading
        let isLoading = hasLoadingMessage || needsPolling;

        const isAnswering = hasAnsweringMessage;

        const sessionState = {
            messages: showMsg,
            loading: isLoading,
            answering: isAnswering
        };
        // 🔥 如果检测到加载状态，同时更新SessionStore.originMsgMapRef中的status
        if (isLoading || isAnswering) {
            changeOriginMsgMap({
                [session?.session_id]: {
                    ...SessionStore.originMsgMap[session?.session_id],
                    messages: allMsg,
                    status: isLoading ? 0 : isAnswering ? 1 : null // 0表示加载中，1表示回答中
                }
            });
        } else {
            // 🔥 新增：如果不是loading状态，确保清除status
            changeOriginMsgMap({
                [session?.session_id]: {
                    ...SessionStore.originMsgMap[session?.session_id],
                    messages: allMsg,
                    status: null // 清除状态
                }
            });
        }

        this.changeSessionMapItem(session?.session_id, sessionState, allMsg);
    };
    //查询后端的某个会话消息记录
    handleGetSessionMessage = async (session, sessionSkill) => {
        let skill =
            sessionSkill ||
            SkillStore.originSkillList.find((item) => {
                return String(item.ability_id) === String(session?.skill_id);
            });

        setCurSkill(skill);

        if (SkillStore.isChatBIype(skill?.ability_id)) {
            // TODO: 处理ChatBI类型
            // if (chatBIRef.current && typeof chatBIRef.current.updateHistoryMsg === 'function') {
            //     if (session.session_id) {
            //         chatBIRef.current.updateHistoryMsg(1, String(session.session_id));
            //     }
            // }
            return false;
        }

        this.setRecordLoading(true);
        let res;
        let isBasic = SkillStore.isFileChatType(session?.skill_id);

        // 🔥 关键修复：先获取历史消息，根据实际的handler字段决定处理方式
        // 🔥 第一步：先尝试获取通用历史记录，检查handler类型
        const preliminaryRes = await handleHistoryRecord({ session_id: session.session_id }, isBasic).catch((err) => {
            console.error('🔥 获取历史记录失败:', err);
            return null;
        });

        // 🔥 第二步：根据历史消息的实际handler类型或content_type，选择对应的处理函数
        if (preliminaryRes && preliminaryRes.success && preliminaryRes.data && preliminaryRes.data.length > 0) {
            const firstMessage = preliminaryRes.data[0];
            const actualHandler = firstMessage.handler;
            const contentType = firstMessage.content_type;

            // 🔥 关键修复：检查是否包含AIPPT类型的消息（即使handler不是aippt）
            const hasAipptContent = preliminaryRes.data.some((msg) => msg.content_type && msg.content_type.startsWith('aippt_'));

            // 🔥 根据实际的handler或content_type分发到对应的处理函数
            if (actualHandler === 'deerflow') {
                // DeerFlow 消息 - 使用无 hook 依赖的共享 service 来处理历史（store 可直接调用）
                try {
                    res = await handleDeerFlowHistoryRequest(session, {
                        checkIsLogin: this.checkIsLogin.bind(this),
                        formatHistoryRecord: this.formatHistoryRecord.bind(this),
                        changeSessionMapItem: this.changeSessionMapItem.bind(this),
                        changeOriginMsgMapRef: SessionStore.changeOriginMsgMap,
                        originMsgMapRef: SessionStore.originMsgMap,
                        startHistoryPolling: (this.deerFlowHook && this.deerFlowHook.startHistoryPolling) || null,
                        formatSessionList: this.formatSessionList.bind(this),
                        linkToSession: this.linkToSession.bind(this),
                        currentSessionMapIdRef: SessionStore.currentSessionMapId,
                        skillListRef: SkillStore.originSkillList
                    });
                } catch (e) {
                    console.error('DeerFlow history service error:', e);
                } finally {
                    this.setRecordLoading(false);
                }

                if (res) {
                    // DeerFlow 历史记录已经在 service 中处理完成
                    return;
                }
            } else if (actualHandler === 'aippt' || hasAipptContent) {
                // 🔥 关键修复：AIPPT 消息 - 直接使用 useAippt 提供的处理函数（不要依赖 this.aipptHook）
                await handleAIPPTHistoryMessageCore(
                    this.changeSessionMapItem ? this.changeSessionMapItem.bind(this) : () => {},
                    preliminaryRes.data,
                    session
                );
                this.setRecordLoading(false);
            } else {
                // 通用消息 - 使用通用处理
                await this.handelSessionHistoryMessage(preliminaryRes.data, session);
                this.setRecordLoading(false);
            }
        } else {
            if (SkillStore.isDeerFlowType(session.skill_id)) {
                try {
                    res = await handleDeerFlowHistoryRequest(session, {
                        checkIsLogin: this.checkIsLogin.bind(this),
                        formatHistoryRecord: this.formatHistoryRecord.bind(this),
                        changeSessionMapItem: this.changeSessionMapItem.bind(this),
                        changeOriginMsgMapRef: SessionStore.changeOriginMsgMap,
                        originMsgMapRef: SessionStore.originMsgMap,
                        startHistoryPolling: (this.deerFlowHook && this.deerFlowHook.startHistoryPolling) || null,
                        formatSessionList: this.formatSessionList.bind(this),
                        linkToSession: this.linkToSession.bind(this),
                        currentSessionMapIdRef: SessionStore.currentSessionMapId,
                        skillListRef: SkillStore.originSkillList
                    });
                } catch (e) {
                    console.error('DeerFlow history service error:', e);
                } finally {
                    this.setRecordLoading(false);
                }

                if (res) {
                    return;
                }
            } else {
                this.setRecordLoading(false);
                console.error('🔥 handleGetSessionMessage - API响应失败或无数据:', preliminaryRes);
            }
        }
    };
    goHome = () => {
        let homeUrl = `${window.location.origin}/agent/${this.side}/o/${this.agentId}/chat`;
        window.location.href = homeUrl;
    };
    handleOutLogin = async () => {
        let { logout_config = {} } = grtAiStore.loginAndOutConfig,
            { logout_redirect_type = 0, can_logout = 0 } = logout_config;
        let res = await outLogin();
        if (res && res.success) {
            Storage.remove('userInfo');
            if (logout_redirect_type === 1 && can_logout === 1) {
                //开启退出登录&&自定义退出登录页
                let url = this.side === 'web' ? logout_config?.pc : logout_config?.h5;
                window.location.href = url;
                return false;
            }
            this.goHome();
            return false;
        }
    };
    clickGuide = (item) => {
        if (item.link_target === 1) {
            let skill = SkillStore.originSkillList.find((ele) => ele.ability_id === item.ability_id);
            if (skill) {
                this.choseApartSkill(skill);
            }
        } else {
            try {
                let url = new URL(item?.custom_url);
                // window.open(url);
                window.open(url, '_blank', 'noopener,noreferrer');
                return true;
            } catch (err) {
                ToastUtils.showAbnormalToast('无效的链接');
                return false;
            }
        }
    };
    //切换工具
    changeTool = () => {
        // changeSession({});
        // closeMultimodalPanel(true); // 切换会话/工具时清空引用
        setCurSkill({});
        changeCurrentSessionMapId(null);
    };
    //切换会话
    changeSession = async (session) => {
        let { originSkillList } = SkillStore;

        let temSkill = originSkillList.find((ele) => {
            return String(ele.ability_id) === String(session.skill_id);
        });

        if (isSkillNeedLogin(temSkill)) {
            let isLogin = await this.checkIsLogin();
            if (!isLogin) {
                return false;
            }
        }
        ModalStore.clearExpandModalIds();
        if (!session?.session_id) {
            changeCurrentSessionMapId(session.session_id);
            return false;
        }
        if (SessionStore.currentSessionMapId === session.session_id) {
            return false;
        }
        multimodalStore.setMultimodalReference(null);
        this.setReferences([]);
        this.clearSendData();
        changeCurrentSessionMapId(session.session_id);
        // SessionStore.currentSessionMapIdList.current = session;todo给chatbi传递的值

        this.handleGetSessionMessage(session, temSkill);
        this.linkToSession(session.session_id);
        // ConfigFactory(SessionStore.currentSessionMapId, SessionStore.currentSessionMapId);
    };
    //处理指定某个会话--更新其消息、loading等
    changeSessionMapItem = (mapId, data, originData) => {
        let { currentSessionMapId, sessionMap } = SessionStore;
        let key = mapId || currentSessionMapId;
        if (!key) {
            return false;
        }
        let targetMapItem = {};
        if (sessionMap[key]) {
            targetMapItem = sessionMap[key];
        }

        let newItem = {
            ...targetMapItem,
            ...data
        };

        setSessionMap({
            [key]: newItem
        });
        if (originData) {
            const newMessages = cloneDeep(originData);
            changeOriginMsgMap({
                [key]: {
                    ...SessionStore.originMsgMap[key],
                    messages: newMessages
                }
            });
        }
    };
}
export default new ChatStore();
